import { render } from "./CountryItem.vue?vue&type=template&id=38cb76ee&scoped=true"
import script from "./CountryItem.vue?vue&type=script&lang=js"
export * from "./CountryItem.vue?vue&type=script&lang=js"

import "./CountryItem.vue?vue&type=style&index=0&id=38cb76ee&lang=scss&scoped=true"

import exportComponent from "C:\\Devprojects\\cedaci-compass\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cb76ee"]])

export default __exports__